import jwt_decode from "jwt-decode";

interface DecodedToken {
  id: string;
  exp: number;
  iat: number;
  roles: any[];
}

const storeToken = (token: string) => {
  localStorage.setItem("access_token", token);
};

const removeToken = () => {
  localStorage.removeItem("access_token");
};

const decodeToken = (): DecodedToken | null => {
  const token = localStorage.getItem("access_token");
  if (!token) return null;
  try {
    return jwt_decode<DecodedToken>(token);
  } catch (error) {
    console.error("Invalid token", error);
    return null;
  }
};

const isTokenExpired = (): boolean => {
  const decoded = decodeToken();
  if (!decoded || !decoded.exp) return true;
  // exp je u sekundama, Date.now() u ms
  return decoded.exp * 1000 <= Date.now();
};

const getToken = (): string => {
  if (isTokenExpired()) {
    removeToken();
    return "";
  }
  return localStorage.getItem("access_token") || "";
};

const getUserIdFromToken = () => {
  const decoded = decodeToken();
  if (!decoded) return null;
  if (decoded.exp * 1000 <= Date.now()) {
    removeToken();
    return null;
  }
  return decoded.id;
};

const getUserRolesFromToken = () => {
  const decoded = decodeToken();
  if (!decoded) return null;
  if (decoded.exp * 1000 <= Date.now()) {
    removeToken();
    return null;
  }
  return decoded.roles;
};

const tokenHelper = {
  storeToken,
  removeToken,
  getToken,
  getUserIdFromToken,
  getUserRolesFromToken,
  isTokenExpired,
};

export default tokenHelper;
